import { render, staticRenderFns } from "./GoodsCombination.vue?vue&type=template&id=5565a790&scoped=true&"
import script from "./GoodsCombination.vue?vue&type=script&lang=js&"
export * from "./GoodsCombination.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCombination.vue?vue&type=style&index=0&id=5565a790&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5565a790",
  null
  
)

export default component.exports